module.exports = __webpack_public_path__ + "img/app.b6546d60.png";